import head from 'lodash/head';
import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { Action } from '@atlassian/react-sweet-state';
import { ZOOM_CHAT_TYPE, ZOOM_SCOPE_TYPE, ZOOM_APP_TYPE } from '../../../common/constants';
import { FETCH_ZOOM_WORKSPACE_CONNECTIONS_ERROR } from '../../constants';
import type { ContainerProps, State, CommunicationWorkspaceConnection } from '../../types';

export type Response = {
	data: CommunicationWorkspaceConnection[];
};

export const fetchZoomWorkspaceConnectionForProject =
	(): Action<State, ContainerProps> =>
	async ({ getState, setState }, { cloudId, analyticsEvent }) => {
		const { zoomWorkspaceConnections } = getState();

		if (zoomWorkspaceConnections.isLoading) {
			return;
		}

		setState({
			zoomWorkspaceConnections: {
				...zoomWorkspaceConnections,
				isLoading: true,
				error: undefined,
			},
		});

		try {
			const response: Response = await performGetRequest(
				`/gateway/api/chatplatform/opsgenie/${cloudId}/api/internal-api/v3/chat/connections?appType=${ZOOM_APP_TYPE}&chatType=${ZOOM_CHAT_TYPE}&scopeType=${ZOOM_SCOPE_TYPE}&scopeId=${cloudId}`,
			);

			setState({
				zoomWorkspaceConnections: {
					data: head(response?.data),
					isLoading: !!response?.data?.length,
					isZoomEnabled: false,
					isConnected: false,
					isChangeInStatusProgress: false,
				},
			});
			fireOperationalAnalytics(analyticsEvent, 'fetchZoomWorkspaceConnectionForProject succeeded');
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			trackFetchErrors({
				event: analyticsEvent,
				error: e,
				id: 'fetchZoomWorkspaceConnectionForProject',
				sendToPrivacyUnsafeSplunk: true,
				packageName: 'jiraServicedeskIncidentManagementSettings',
			});
			setState({
				zoomWorkspaceConnections: {
					data: undefined,
					isLoading: false,
					isZoomEnabled: false,
					isConnected: false,
					isChangeInStatusProgress: false,
					error: { value: e.message, type: FETCH_ZOOM_WORKSPACE_CONNECTIONS_ERROR },
				},
			});
		}
	};
